<template>
  <div class="hll-steps-box flex">
    <div v-for="(item, $index) in stepsList" :key="$index"
         :class="['step-item', 'flex-1', {'step-active': curStep >= $index}]">
      <div class="step-line">
        <span class="step-index">{{$index +1}}</span>
      </div>
      <div class="step-name">{{item}}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'hllSteps',
    props: {
      stepsList: {
        type: Array,
        default: []
      },
      stepIndex: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        curStep: 0 // 当前步骤 从0开始
      }
    },
    watch: {
      stepIndex(newVal) {
        if(newVal !== this.curStep) {
          this.curStep = newVal
        }
      }
    },
    mounted() {
      this.curStep = this.stepIndex
    }
  }
</script>

<style lang="scss" scoped>
  .hll-steps-box {
    .step-item {
      padding-top: 14px;
      margin-right: 1px;
      &:last-child {
        margin-right: 0;
      }
    }
    .step-line {
      width: 100%;
      height: 6px;
      background: #919191;
      position: relative;
    }
    .step-index {
      position: absolute;
      left: 50%;
      top: -14px;
      margin-left: -17px;
      width: 34px;
      height: 34px;
      font-size: 18px;
      line-height: 34px;
      text-align: center;
      background: #919191;
      color: #fff;
      border-radius: 17px;
    }
    .step-name {
      color: #919191;
      margin-top: 21px;
      text-align: center;
    }
    .step-active {
      .step-line {
        background: #F16222;
      }
      .step-index {
        background: #F16222;
      }
      .step-name {
        color: #F16222;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/hll-steps.vue